import CalendarMain from "@/views/reminder/components/calendar/CalendarMain.vue"
import SettingsReminder from "@/views/reminder/components/settings/SettingsReminder.vue"

export const router_reminder_client = [
    {
        path: "reminder",
        name: "Reminder",
        component: CalendarMain
    },
    {
        path: "settingsReminder",
        name: "SettingsReminder",
        component: SettingsReminder
    }
]
